'use strict';

var log = require('../../log/Log').channel('SetupPairingController');
var defaults = require ('../../defaults/Defaults');
require('./KayleeService');
var moment = require('moment');

angular.module('inara').controller('SetupPairingController', 
                                   SetupPairingController);

SetupPairingController.$inject = ['$scope', '$state', '$timeout', '$interval',
                                  '$document', 'KayleeService', 'RoomService',
                                  '$q', 'gettextCatalog'];

function SetupPairingController($scope, $state, $timeout, $interval,
                                $document, KayleeService, RoomService,
                                $q, gettextCatalog) {
    var vm = this;
    var requestTime = 0;
    var firstControllerChanged = true;
    var controllerChangedConnected = false;
    var codeExpiredTimeout = null;
    var controllerLoadedTimeout = null;
    var checkingConnection = false;
    var offlineMessageTimeout = null;
    var checkingConnectionTimeout = null;
    var initialCheckingConnectionTime = 10000;
    var checkingConnectionTime = 3000;
    var offlineMessageTime = 10000;
    var pairHappened = false;
    var unpairHappened = false;
    
    vm.portalName = defaults.mal.name;
    vm.inaraName = defaults.inara.name;
    vm.pairingState = 'initializing';

    log.info('initializing');

    $scope.$on('$ionicView.beforeEnter', function() {
        pairHappened = false;
        unpairHappened = false;
        if (!vm.isMalConnected()) {
            startCheckingConnection();
        }
    });

    $scope.$on('$ionicView.enter', function() {
        KayleeService.onConnectionStateChanged(onKayleeOnlineChanged);
    });

    function connectControllerChanged() {
        firstControllerChanged = true;
        controllerLoadedTimeout = null;
        var controller = RoomService.getController();
        if (controller === null) {
            controllerLoadedTimeout = $timeout(connectControllerChanged, 500);
            return;
        }
        requestTime = 0;
        if (!controllerChangedConnected) {
            log.debug('enabling onControllerChanged');
            controller.$onChange(onControllerChanged);
            controllerChangedConnected = true;
        }
    }

    function disconnectControllerChanged() {
        var controller = RoomService.getController();
        if (controller !== null &&
            controllerChangedConnected) {
            log.debug('disabling onControllerChanged');
            controller.$offChange(onControllerChanged);
            controllerChangedConnected = false;
        }
    }

    $scope.$on('$stateChangeSuccess', function(event, toState, toParams, 
                                               fromState, fromParams) {
        if (fromState.name === 'setup.pairing') { 
            if (controllerLoadedTimeout !== null) {
                $timeout.cancel(controllerLoadedTimeout);
                controllerLoadedTimeout = null;
            }
            disconnectControllerChanged();
            if (codeExpiredTimeout !== null) {
                $timeout.cancel(codeExpiredTimeout);
            }
            KayleeService.offConnectionStateChanged(onKayleeOnlineChanged);
            cancelTimeouts();
        }
    });

    function cancelTimeouts() {
        if (offlineMessageTimeout !== null) {
            $timeout.cancel(offlineMessageTimeout);
            offlineMessageTimeout = null;
        }
        if (checkingConnectionTimeout !== null) {
            $timeout.cancel(checkingConnectionTimeout);
            checkingConnectionTimeout = null;
        }
    }

    function onKayleeOnlineChanged(online) {
        log.debug('onKayleeOnlineChanged: ' + (online ? 'online' : 'offline'));
        if (online) {
            if ($state.is('setup.pairing')) {
                connectControllerChanged();
                cancelTimeouts();
            } else {
                disconnectControllerChanged();
            }
        } else {
            if ($state.is('setup.pairing')) {
                startCheckingConnection();                
            }
        }
    }

    function startCheckingConnection() {
        checkingConnection = true;
        if (checkingConnectionTimeout !== null) {
            $timeout.cancel(checkingConnectionTimeout);
        }
        checkingConnectionTimeout = 
            $timeout(onCheckingConnectionTimeout, initialCheckingConnectionTime);
    }

    function onOfflineMessageTimeout() {
        checkingConnection = true;
        if (checkingConnectionTimeout !== null) {
            $timeout.cancel(checkingConnectionTimeout);
        }
        checkingConnectionTimeout = 
            $timeout(onCheckingConnectionTimeout, checkingConnectionTime);
    }

    function onCheckingConnectionTimeout() {
        checkingConnection = false;
        checkingConnectionTimeout = null;
        if (offlineMessageTimeout !== null) {
            $timeout.cancel(offlineMessageTimeout);
        }
        offlineMessageTimeout = 
            $timeout(onOfflineMessageTimeout, offlineMessageTime);
    }

    function onControllerChanged(controller) {
        var prevPairingState = vm.pairingState;

        if (controller.hasOwnProperty('roomId')) {
            vm.pairingState = 'paired';

            if (!firstControllerChanged) {
                if (prevPairingState === 'code') {
                    pairHappened = true;
                }
                if (prevPairingState !== 'paired') {
                    log.debug('onControllerChanged: forcing state to setup.summary');
                    $scope.goTo('setup.summary');
                }
            }
        } else if (controller.hasOwnProperty('pairing')) {
            var now = Date.now();

            if (controller.pairing.expires >= now) {
                vm.pairingState = 'code';

                if (codeExpiredTimeout !== null) {
                    $timeout.cancel(codeExpiredTimeout);
                }

                codeExpiredTimeout = 
                    $timeout(onCodeExpired, controller.pairing.expires - now);
            } else {
                if (requestTime > controller.pairing.time) {
                    vm.pairingState = 'requesting';
                }
                else {
                    vm.pairingState = 'expired';
                }
            }
        } else if (vm.pairingState !== 'requesting') {
            vm.pairingState = 'nocode';
        }

        if (prevPairingState !== vm.pairingState) {
            log.debug('pairing state changed from ' + prevPairingState +
                ' to ' + vm.pairingState);
            prevPairingState = vm.pairingState;
        }

        if ((vm.pairingState === 'nocode' ||
            vm.pairingState === 'error' ||
            vm.pairingState === 'expired' && firstControllerChanged) &&
            requestTime === 0 &&
            vm.isMalConnected()) {
            vm.requestPairingCode();
        }

        firstControllerChanged = false;
    }

    vm.isMalConnected = function() {
        return KayleeService.isConnected();
    };

    vm.isControllerLoaded = function() {
        return RoomService.isControllerLoaded();
    };

    vm.askToUnpair = function() {
        return !pairHappened &&
               !unpairHappened &&
            RoomService.isControllerLoaded() &&
            RoomService.getController().hasOwnProperty('roomId');
    };

    vm.getMalConnectionMessages = function() {
        if (!vm.isMalConnected()) {
            if (checkingConnection) {
                return [
                    /// Status message for setup while checking connection to Mira Portal
                    gettextCatalog.getString('Checking connection to {{portalName}}...', 
                        { portalName: defaults.mal.name })
                ];
            } else {
                return [
                    /// Error message for setup while checking connection to Mira Portal (part 1/2)
                    gettextCatalog.getString('Could not connect to {{portalName}}.', 
                        { portalName: defaults.mal.name }),
                    /// Error message for setup while checking connection to Mira Portal (part 2/2)
                    gettextCatalog.getString('Check that the connected network has access to the ' +
                        'internet and try again.')
                ];
            }
        }
        return;
    };

    vm.isCheckingMalConnection = function() {
        return checkingConnection;
    };

    vm.getCompanyName = function() {
        if (!RoomService.isRoomLoaded()) return '';
        var room = RoomService.getRoom();
        return KayleeService.getCompany(room.companyId).name;        
    };

    vm.getSiteName = function() {
        if (!RoomService.isRoomLoaded()) return '';
        var room = RoomService.getRoom();
        return KayleeService.getSite(room.siteId).name;
    };

    vm.getRoomName = function() {
        if (!RoomService.isRoomLoaded()) return '';
        var room = RoomService.getRoom();
        return room.name;
    };

    vm.getViewTitle = function() {
        /// Title bar for setup page to pair Mira Connect to a room
        return gettextCatalog.getString('Pair {{inaraName}} to Room', 
            { inaraName: $scope.inaraName });
    };

    vm.unpair = function() {
        if (RoomService.isControllerLoaded()) {
            unpairHappened = true;
            RoomService.getController().$unpair();
        }
    };

    vm.goToSummary = function() {
        $scope.goTo('setup.summary');
    };

    function onCodeExpired() {
        codeExpiredTimeout = null;
        requestTime = 0;
        vm.pairingState = 'expired';
    }

    vm.getPairingCode = function() {
        var controller = RoomService.getController();

        if (controller !== null &&
            controller.hasOwnProperty('pairing') &&
            controller.pairing.hasOwnProperty('code')) {
            return groupPairingCodeElements(controller.pairing.code);
        }

        return [''];
    };

    function groupPairingCodeElements(pairingCode) {
        var elements = [];
        var elementLength = 3;
        for (var i = 0; i < pairingCode.length; i += elementLength) {
            elements.push(pairingCode.slice(i, i + elementLength));
        }
        return elements;
    }

    vm.requestPairingCode = function() {
        var controller = RoomService.getController();
        if (controller === null) return;

        if (requestTime > 0 &&
            (controller.hasOwnProperty('pairing') &&
             controller.pairing.hasOwnProperty('time') &&
             controller.pairing.time >= requestTime ||
             !controller.hasOwnProperty('pairing'))) {
            log.warning('pairing code already requested');
            return;
        }

        log.info('requesting pairing code');
        requestTime = Date.now();
        vm.pairingState = 'requesting';
        return controller.$requestPairingCode().catch(function(error) {
            vm.pairingState = 'error';
            requestTime = 0;
        });
    };

    vm.getExpirationDuration = function() {
        var controller = RoomService.getController();
        if (controller === null) return moment().add(60, 'minutes').fromNow();

        var defaultThreshold = moment.relativeTimeThreshold('m');
        var defaultRounding = moment.relativeTimeRounding();

        // Adjust moment's duration threshold and rounding to show 
        // "in 60 minutes" rather than the default of 45 minutes appearing as 
        // "in an hour".
        moment.relativeTimeThreshold('m', 61);
        moment.relativeTimeRounding(Math.ceil);
        var duration = controller.hasOwnProperty('pairing') ? 
            moment(controller.pairing.expires).fromNow() :
            moment().add(60, 'minutes').fromNow();
        moment.relativeTimeThreshold('m', defaultThreshold);
        moment.relativeTimeRounding(defaultRounding);
        return duration;
    };
}

module.exports = SetupPairingController;
